import swal from 'sweetalert'

// Track when the page is unloading so we can suppress spurious error popups
// caused by browsers (notably Firefox) aborting in-flight requests during
// navigation/redirects (e.g., OAuth sign-in flows).
let isUnloading = false
if (typeof window !== 'undefined') {
  window.addEventListener('beforeunload', () => { isUnloading = true })
  window.addEventListener('pagehide', () => { isUnloading = true })
  window.addEventListener('load', () => { isUnloading = false })
  window.addEventListener('pageshow', () => { isUnloading = false })
}

// Detect errors that are very likely caused by request abortion during
// navigation rather than genuine failures we should show to users.
export const isAbortLikeError = (error) => {
  try {
    const visibilityHidden = typeof document !== 'undefined' && document.visibilityState === 'hidden'
    const noResponse = !(error && error.response)
    let msg = '';
    if (typeof error === 'string') {
      msg = error;
    } else if (error && typeof error === 'object') {
      if (typeof error.message === 'string') {
        msg = error.message;
      } else if (
        typeof error.toString === 'function' &&
        error.toString !== Object.prototype.toString
      ) {
        try {
          msg = error.toString();
        } catch (e) {
          msg = '';
        }
      }
    }
    msg = String(msg).toLowerCase();

    // Browser/Fetch abort signatures
    if (msg.includes('aborterror')) return true
    if (msg.includes('ns_binding_aborted')) return true
    if (msg.includes('networkerror when attempting to fetch resource')) return true

    // Axios often surfaces navigation-aborted XHR as a generic "Network Error"
    // with no response. Only suppress when the page is unloading/hidden to avoid
    // masking real connectivity issues during normal app usage.
    if (noResponse && (isUnloading || visibilityHidden)) return true

    // Some environments mark aborted/timeout with this code; again, guard by
    // page lifecycle state to avoid over-suppressing.
    if ((error && error.code === 'ECONNABORTED') && (isUnloading || visibilityHidden)) return true

    return false
  } catch (e) {
    return false
  }
}

export const handle401Error = () => {
  let rememberMe = ""
  if (localStorage.getItem("rememberMe")) {
    rememberMe = localStorage.getItem("rememberMe")
  }
  localStorage.clear()
  if (rememberMe) {
    localStorage.setItem("rememberMe", rememberMe)
  }
  window.location = '/'
}

export const errorFetchingDataAlert = (message = "There was an error fetching your data") => {
  return swal({
    title: "Error",
    text: message,
    icon: "error",
    button: "Continue",
  })
}

export const handleErrorFetchingData = (error, message) => {
  // Suppress aborted/canceled requests that happen during navigation/redirects,
  // notably in Firefox where in-flight XHR/fetch are aggressively canceled.
  if (isAbortLikeError(error)) {
    // Optionally log for diagnostics without distracting the user
    if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('[suppress] abort-like error during navigation:', error)
    }
    return
  }

  if (error.response && error.response.status && error.response.status === 401) {
    return handle401Error()
  }
  if (error.response && error.response.data && error.response.data.message) {
    message = error.response.data.message
  }
  return errorFetchingDataAlert(message)
}



// WEBPACK FOOTER //
// ./src/functions/errorHandling.js